import React from "react";
import { Link } from "react-router-dom";

export default function PublicHeader() {
  return (
    <header className="sticky top-0 z-50 glass border-b border-white/10" style={{ background: "rgba(5,5,5,0.6)" }}>
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="font-heading font-extrabold text-xl tracking-tighter">
          adyap<span className="text-primary">.</span>
        </Link>
        <div className="flex items-center gap-3">
          <Link to="/login" data-testid="nav-login-link" className="text-sm text-zinc-300 hover:text-white px-4 py-2 transition-colors">
            Sign in
          </Link>
          <Link
            to="/signup"
            data-testid="nav-signup-link"
            className="text-sm bg-white text-black hover:bg-zinc-200 px-4 py-2 rounded-full font-medium transition-colors"
          >
            Get started
          </Link>
        </div>
      </div>
    </header>
  );
}
